import { CLUB_BUILDER_PRODUCTS } from '../components/ProductSourceModal';
import type { TierDiscount, TierFreeShipping } from '../types/loyaltyTiers';

// Pulled from Shopify in the real build; mocked here for the prototype.
export const TIER_COLLECTIONS = ['Estate', 'Reserve', 'Red Wines', 'White Wines', 'Rosé', 'Sparkling', 'Library Releases'];

export const COLLECTION_PRODUCT_COUNTS: Record<string, number> = {
  Estate: 14,
  Reserve: 6,
  'Red Wines': 22,
  'White Wines': 15,
  Rosé: 4,
  Sparkling: 5,
  'Library Releases': 9
};

export const NO_TIER_DISCOUNT: TierDiscount = {
  enabled: false,
  percent: 10,
  appliesTo: 'all',
  collections: [],
  productIds: []
};

// "Estate", "Estate and Reserve", "Estate, Reserve and Sparkling"
function joinNames(names: string[]): string {
  if (names.length <= 1) return names[0] ?? '';
  return `${names.slice(0, -1).join(', ')} and ${names[names.length - 1]}`;
}

function discountTarget(discount: TierDiscount): string {
  if (discount.appliesTo === 'all') return 'all products';
  if (discount.appliesTo === 'collections') return discount.collections.length > 0 ? joinNames(discount.collections) : 'a collection';
  if (discount.productIds.length === 1) {
    return CLUB_BUILDER_PRODUCTS.find(product => product.id === discount.productIds[0])?.name ?? '1 product';
  }
  return `${discount.productIds.length} products`;
}

function shippingLabel(shipping: TierFreeShipping): string | null {
  if (shipping.mode === 'all') return 'Free shipping';
  if (shipping.mode === 'over') return `Free shipping over $${shipping.minimum.toLocaleString()}`;
  return null;
}

// e.g. "20% off Estate and Reserve · Free shipping"; empty when nothing is set
export function summariseTierBenefits(discount: TierDiscount, shipping: TierFreeShipping): string {
  const discountText = discount.enabled && discount.percent > 0 ? `${discount.percent}% off ${discountTarget(discount)}` : null;
  return [discountText, shippingLabel(shipping)].filter(Boolean).join(' · ');
}
